import React, { useEffect, useMemo } from 'react';
import { Form } from 'antd';
import DesktopQuickStatusUpdate from './desktop';
import MobileQuickStatusUpdate from './mobile';

const PAYMENT_STATUS_OPTIONS = [
  { id: 'unpaid', title: 'Chờ thanh toán' },
  { id: 'partial', title: 'Thanh toán 1 phần' },
  { id: 'paid', title: 'Đã thanh toán' },
  { id: 'waiting_verification', title: 'Chờ xác nhận thanh toán' },
];

const SHIPPING_STATUS_OPTIONS = [
  { id: 'not_shipped', title: 'Chờ vận chuyển' },
  { id: 'shipping', title: 'Đang vận chuyển' },
  { id: 'shipped', title: 'Đã giao' },
];

const ORDER_STATUS_OPTIONS = [
  { id: 'proccesing', title: 'Đang xử lý' },
  { id: 'finalized', title: 'Đã hoàn tất' },
  { id: 'canceled', title: 'Đã huỷ' },
];

const QuickStatusUpdate = ({
  isMobile,
  open,
  loading,
  initialValues,
  internalStatusOptions,
  onClose,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      return;
    }

    form.setFieldsValue(initialValues || {});
  }, [form, initialValues, open]);

  const orderStatusOptions = useMemo(
    () => ORDER_STATUS_OPTIONS.map((item) => ({ label: item.title, value: item.id })),
    []
  );

  const paymentStatusOptions = useMemo(
    () => PAYMENT_STATUS_OPTIONS.map((item) => ({ label: item.title, value: item.id })),
    []
  );

  const shippingStatusOptions = useMemo(
    () => SHIPPING_STATUS_OPTIONS.map((item) => ({ label: item.title, value: item.id })),
    []
  );

  const mappedInternalStatusOptions = useMemo(
    () => (internalStatusOptions || []).map((item) => ({ label: item.title, value: item.id })),
    [internalStatusOptions]
  );

  const submit = async () => {
    const values = await form.validateFields();
    await onSubmit?.(values);
  };

  const commonProps = {
    open,
    loading,
    onClose,
    onSubmit: submit,
    form,
    orderStatusOptions,
    paymentStatusOptions,
    shippingStatusOptions,
    internalStatusOptions: mappedInternalStatusOptions,
  };

  if (isMobile) {
    return <MobileQuickStatusUpdate {...commonProps} />;
  }

  return <DesktopQuickStatusUpdate {...commonProps} />;
};

export default QuickStatusUpdate;
